import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Google Analytics 4 (gtag.js) — loaded only when a Measurement ID is configured,
// and only on the internal portal (never on the public /checkin guest pages).
export const useGoogleAnalytics = () => {
  const location = useLocation();
  useEffect(() => {
    const id = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (!id) return;                               // no ID configured yet → no-op
    if (location.pathname.startsWith("/checkin")) return; // exclude public guest pages
    if (window.__gaLoaded) return;                 // load the script only once
    window.__gaLoaded = true;

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", id);
  }, [location.pathname]);
};

export const Analytics = () => {
  useGoogleAnalytics();
  return null;
};
